import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";

import { Amplify } from "aws-amplify"; // For interaction with AWS services
import "@aws-amplify/ui-react/styles.css"; // Default styles for Amplify UI components
import outputs from "./amplify_outputs.json"; // Gen 2 backend outputs (written into src/ by ampx --outputs-out-dir src)

// Configure the Amplify library with the Gen 2 backend outputs.
Amplify.configure(outputs);

// Register the custom REST API (defined via CDK in amplify/backend.ts) so that
// `post({ apiName: "ApplePayMerchantValidation" })` continues to resolve.
const existingConfig = Amplify.getConfig();
Amplify.configure({
  ...existingConfig,
  API: {
    ...existingConfig.API,
    REST: {
      ...existingConfig.API?.REST,
      ApplePayMerchantValidation: {
        endpoint: outputs.custom.API.ApplePayMerchantValidation.endpoint,
        region: outputs.custom.API.ApplePayMerchantValidation.region,
      },
    },
  },
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
